export default [
    //租赁库存清单
    {
        path: '/warehouse/leaseInventoryList',
        component: require('@/views/Warehouse/LeaseInventoryList/Index').default
    },
    //出售库存清单
    {
        path: '/warehouse/sellInventoryList',
        component: require('@/views/Warehouse/SellInventoryList/Index').default
    },
    //出租中清单
    {
        path: '/warehouse/rentingList',
        component: require('@/views/Warehouse/RentingList/Index').default
    },
    //已出售清单
    {
        path: '/warehouse/sellList',
        component: require('@/views/Warehouse/SellList/Index').default
    },
    //押金列表清单
    {
        path: '/warehouse/depositList',
        component: require('@/views/Warehouse/Deposit/Index').default
    },
    //老师分配表
    {
        path: '/warehouse/teacherDistribution',
        component: require('@/views/Warehouse/TeacherDistribution/Index').default
    },
    //商品清单
    {
        path: '/warehouse/storeList',
        component: require('@/views/Warehouse/Store/List/Index').default
    },
    //商品清单
    {
        path: '/warehouse/shopMsgList/:id',
        component: require('@/views/Warehouse/Store/ShopMsgList/Index').default
    },

]

